<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>

    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title>{{ $t('Visa-Price') }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <a
              target="_self"
              v-bind:href="'#/coper/tanitimlar/vizefiyat/islem/id?isl=yeni'"
            >
              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Save" slot="activator" flat>
                  <span class="hidden-sm-and-down"> {{ $t('Add')}} </span>
                  <v-icon right dark>add_box</v-icon>
                </v-btn>
                <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Save">{{ $t('New') }}</span>
              </v-tooltip>
            </a>
          </v-toolbar>
        </v-flex>

        <v-flex xs12 sm12 md12 pa-3>
          <v-card class="pa-2">
            <v-layout row wrap align-center>
              <v-flex xs12 sm12 md3>
                <konsoloslukminiara v-model="vizeFiyatParams.Konsolosluk">
                </konsoloslukminiara>
              </v-flex>

              <v-flex xs12 sm12 md2>
                <tarihim
                  v-model="vizeFiyatParams.Donem1Bas"
                  :etiket="$t('Term-Start') + '1'"
                  v-bind:defaultvalue="'ok'"
                  :detaygizle="true"
                ></tarihim>
              </v-flex>

              <v-flex xs12 sm12 md1>
                <v-btn color="info" fab small @click="getVizeFiyatList()"
                  ><v-icon>search</v-icon></v-btn
                >
              </v-flex>

              <v-flex
                xs12
                sm12
                md5
                class="headline font-weight-regular pl-3 grey--text"
              >
                <!-- toplam kayıt sayısı yazılabilir -->
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>

        <v-container fluid grid-list-sm>
          <v-flex
            v-for="item in cardItems"
            v-bind:key="item.SiraNo"
            pb-3
            xs12
            sm12
            md12
          >
            <v-hover>
              <v-card
                width="100%"
                slot-scope="{ hover }"
                :class="`elevation-${hover ? 12 : 2}`"
                class="elevation-1 pa-3"
              >
                <v-layout row wrap align-center justify-end>
                  <v-flex xs12 sm6 md3>
                    <v-layout row wrap>
                      <v-flex
                        xs12
                        sm12
                        md12
                        class="font-weight-medium grey--text caption"
                      >
                        <v-icon color="#67768f" small
                          >fiber_manual_record</v-icon
                        >
                        {{ item.Tip1 }}
                      </v-flex>
                      <v-flex
                        xs12
                        sm12
                        md12
                        class="font-weight-bold grey--text caption"
                      >
                        <v-icon color="#67768f" small>payment</v-icon>
                        {{ item.SaticiKodu }}
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm6 md2>
                    <v-flex
                      xs12
                      sm12
                      md12
                      style="color: #67768f"
                      class="font-weight-medium grey--text caption"
                      ><span style="color: #67768f">{{ $t('Visa-Starting-Date') }} :</span
                      >{{ item.Donem1 | dateformat }}</v-flex
                    >
                    <v-flex
                      xs12
                      sm12
                      md12
                      style="color: #67768f"
                      class="font-weight-medium grey--text caption"
                      ><span style="color: #67768f">{{$t('Visa-Expiry-Date')}} :</span
                      >{{ item.Donem2 | dateformat }}</v-flex
                    >
                    <v-flex
                      xs12
                      sm12
                      md12
                      style="color: #67768f"
                      class="font-weight-medium grey--text caption"
                      ><span style="color: #67768f">{{$t('Visa-Price-Type')}} :</span
                      >{{ item.FiyatTipi.isim }}</v-flex
                    >
                  </v-flex>

                  <v-flex xs12 sm6 md2>
                    <v-flex
                      xs12
                      sm12
                      md12
                      style="color: #67768f"
                      class="font-weight-medium grey--text caption"
                    >
                      <span style="color: #67768f">{{ $t('Purchase-Price') }} :</span>
                      {{ item.AlisFiyat | moneyformat }}
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      md12
                      style="color: #67768f"
                      class="font-weight-medium grey--text caption"
                      ><span style="color: #67768f">{{ $t('Currency-Type') }} :</span
                      >{{ item.AlisPara }}</v-flex
                    >
                    <v-flex
                      xs12
                      sm12
                      md12
                      style="color: #67768f"
                      class="font-weight-medium grey--text caption"
                      ><span style="color: #67768f">{{ $t('Currency-Exchange-Rate') }} :</span
                      >{{ item.AlisKur }}</v-flex
                    >
                  </v-flex>

                  <v-flex xs12 sm6 md2>
                    <v-flex
                      xs12
                      sm12
                      md12
                      style="color: #67768f"
                      class="font-weight-medium grey--text caption"
                    >
                      <span style="color: #67768f">{{ $t('Sales-Price') }} :</span>
                      {{ item.SatisFiyat | moneyformat }}
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      md12
                      style="color: #67768f"
                      class="font-weight-medium grey--text caption"
                      ><span style="color: #67768f"> {{ $t('Sales-Money') }}  :</span
                      >{{ item.SatisPara }}</v-flex
                    >
                    <v-flex
                      xs12
                      sm12
                      md12
                      style="color: #67768f"
                      class="font-weight-medium grey--text caption"
                      ><span style="color: #67768f"> {{ $t('Sales-Currency') }}  :</span
                      >{{ item.SatisKur }}</v-flex
                    >
                  </v-flex>

                  <v-flex xs12 sm6 md2>
                    <v-layout row wrap>
                      <v-flex
                        xs12
                        sm12
                        md12
                        class="font-weight-medium grey--text pl-2 caption"
                      >
                        <span style="color: #67768f"> {{$t('Visa-Type')}} : </span>
                        {{ item.VizeCesit.isim }}
                      </v-flex>
                      <v-flex
                        xs12
                        sm12
                        md12
                        class="font-weight-medium grey--text pl-2 caption"
                      >
                        <span style="color: #67768f">{{$t('VAT')}} :</span>
                        {{ item.KDV }}
                      </v-flex>
                      <v-flex
                        xs12
                        sm12
                        md12
                        class="font-weight-medium grey--text pl-2 caption"
                      >
                        <span style="color: #67768f">{{$t('Description')}} :</span>
                        {{ item.Aciklama }}
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm6 md1>
                    <v-layout row wrap>
                      <v-flex
                        xs12
                        sm12
                        md6
                        class="font-weight-medium grey--text caption"
                      >
                        <v-btn
                          color="info"
                          @click="getVizeFiyat(item)"
                          outline
                          v-if="sayfayetki.Update"
                          fab
                          small
                        >
                          <v-icon>search</v-icon>
                        </v-btn>
                      </v-flex>
                      <v-flex
                        xs12
                        sm12
                        md6
                        class="font-weight-medium grey--text caption"
                      >
                        <v-btn
                          v-if="sayfayetki.Delete"
                          color="error"
                          @click="deleteVizeFiyat(item)"
                          outline
                          fab
                          small
                        >
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-hover>
          </v-flex>
        </v-container>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import helpers from "@/components/app/customcomp/helpers.js";
import konsoloslukminiara from "@/components/app/coper/comp/konsoloslukminiara.vue";
import tool from "@/components/app/coper/tools";
import tarihim from "@/components/app/customcomp/tarihim";

export default {
  data() {
    return {
      text1: null,
      snackbar: false,
      yetkidialog: false,
      loadingvmodel: false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      cardItems: [],
      vizeFiyatParams: {
        Konsolosluk: null,
        Donem1Bas: null,
        Donem1Bit: null,
        Donem2Bas: null,
        Donem2Bit: null,
      },
    };
  },
  methods: {
    deleteVizeFiyat(val) {
      this.loadingvmodel = true;
      let params = {
        Id: val.Ref,
      };
      tool.http_post(this, "VizeFiyatDelete", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.getVizeFiyatList();
            this.loadingvmodel = false;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
            this.loadingvmodel = false;
          }
        },
        (response) => {
         this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
          this.loadingvmodel = false;
        }
      );
    },
    getVizeFiyat(val) {
      var url =
        "#/coper/tanitimlar/vizefiyat/islem/id?" + "isl=get&Ref=" + val.Ref;
      window.open(url, "_blank");
    },
    getVizeFiyatList() {
      tool.http_post(this, "VizeFiyatList", this.vizeFiyatParams).then(
        (response) => {
          if (response.body.Status == true) {
            this.cardItems = response.body.data;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
         this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
        }
      );
    },
  },
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },
    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
  },
  components: {
    yetkidialog,
    snackbarcomp,
    loadingcomp,
    konsoloslukminiara,
    tarihim,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
    if (this.sayfayetki.Status == true) {
      //YETKİ OK
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              let url = "#" + this.prevRoute;
              window.open(url, "_self");
            } else {
              let url = "#/";
              window.open(url, "_self");
            }
          }
        });
    }
  },
};
</script>

<style>
</style>

